var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScaffcalcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 239.1 340.7",
    style: {
      enableBackground: "new 0 0 239.1 340.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.5,6.9C180.1,2.5,174.1,0,167.8,0H23.7C10.6,0,0,10.6,0,23.7V317c0,13.1,10.6,23.7,23.7,23.7h191.7 c13.1,0,23.7-10.6,23.7-23.7V170.3l0.2-98.8c0-6.3-2.5-12.4-6.9-16.8L184.5,6.9z M24.4,36.3l165.3,121.8H24.4V36.3z M24.4,316.3 V194.5l165.3,121.8H24.4z M214.7,304.3L49.3,182.5h165.3V304.3z M214.7,146.2L49.3,24.4h111v54.3h54.5L214.7,146.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaffcalcLogo);
export default __webpack_public_path__ + "static/media/ScaffcalcLogo.95f33adc65f3ff13add4d84959582af3.svg";
export { ForwardRef as ReactComponent };